module.exports = __webpack_public_path__ + "static/media/12_tn.325c4bb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/12_tn.jpg
// module id = 442
// module chunks = 0